module.exports = __webpack_public_path__ + "8a4a53c2fd763e5b78cade42b852e219.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-underwater.png
// module id = 2983
// module chunks = 0